/** @format */

import { pythonApiClient } from "./python-api/pythonApiClient";

export const notificationService = {
  async getNotifications() {
    try {
      const response = await pythonApiClient.get('/profile/notifications/');
      return response.data || [];
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
      throw error;
    }
  },

  async markNotificationsAsRead(notificationIds) {
    try {
      const response = await pythonApiClient.put('/profile/notifications/read/', {
        notification_ids: notificationIds
      });
      return response;
    } catch (error) {
      console.error('Failed to mark notifications as read:', error);
      throw error;
    }
  }
};